export default __webpack_public_path__ + "static/media/dimension_wagon.dd8ce874.jpg";